import { render, staticRenderFns } from "./Produit.vue?vue&type=template&id=32949450&scoped=true"
import script from "./Produit.vue?vue&type=script&lang=js"
export * from "./Produit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32949450",
  null
  
)

export default component.exports